import { collection, query, getDocs, doc, updateDoc, orderBy, serverTimestamp } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from './firebase';

const COLLECTION = 'supportRequests';

export const getSupportRequests = async () => {
  const q = query(collection(db, COLLECTION), orderBy('submittedAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const updateSupportRequestStatus = async (id, status) => {
  const updates = { status, updatedAt: serverTimestamp() };
  if (status === 'resolved') updates.resolvedAt = serverTimestamp();
  await updateDoc(doc(db, COLLECTION, id), updates);
};

export const sendSupportReply = async (requestId, replyMessage, newStatus) => {
  const fn = httpsCallable(functions, 'sendSupportReply');
  const result = await fn({ requestId, replyMessage, newStatus });
  return result.data;
};
